export default __webpack_public_path__ + "static/what_is_is_like_to_be-1df342cc8d429ec70d9b3ab0438d93ce.mp4";